import { defineComponent as _defineComponent } from 'vue'
import { ref, inject, Ref, computed } from 'vue';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import {
  BaseText,
  ButtonContainer,
  ButtonPrimary,
  Heading,
  HeadingDisplay,
  ListDisplay,
  MessageFoundation
} from '@warrenbrasil/nebraska-web';

import { IWithdrawSummary } from '@/modules/transaction/services/withdraw-by-portfolio';
import { isImpersonate } from '@/modules/common/services/partner';
import { getUserB2B } from '@/modules/common/services/local-storage';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReviewStep',
  setup(__props) {

const withdrawReview = inject('withdrawReview') as Ref<IWithdrawSummary>;
const sendWithdraw = inject('sendWithdraw', async (partnerId?: string) => ({
  partnerId
}));

const isLoading = ref(false);

const partnerId = computed(() => {
  if (!isImpersonate()) {
    return '';
  }

  const partner = getUserB2B();
  return partner?._id || '';
});

async function handleNextClick() {
  try {
    isLoading.value = true;

    await sendWithdraw(partnerId.value);
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,withdrawReview, sendWithdraw, isLoading, partnerId, handleNextClick, NebraskaColors, BaseText, ButtonContainer, ButtonPrimary, Heading, HeadingDisplay, ListDisplay, MessageFoundation }
}

})